import systemTestApi from "../../api/systemTest"
import { toIsoString } from "../../utils/dateTimeFormatter"
import {getClearedTestKey} from "../../utils/converters"

export default {
    state: {
        anyAnotherUserTests: true,
        isSystemTestScheduled: true,
        startDate: 0,
        duration: 0,
        onTestKey: null,
        clearedTestKey: null
    },
    getters: {
        canPlaceOnTest: state => !state.anyAnotherUserTests && !state.isSystemTestScheduled,
        canExtendTest: state => !state.anyAnotherUserTests && state.isSystemTestScheduled,
        canClearTest: state => !state.anyAnotherUserTests && state.isSystemTestScheduled        
    },
    mutations: {
        setTestStatus(state, status) {
            state.anyAnotherUserTests = status.AnyAnotherUserTests;
            state.isSystemTestScheduled = status.IsSystemTestScheduled;
            state.startDate = status.StartDate;
            state.duration = status.Duration;
        },
        setOnTestKey(state, key) {
            state.onTestKey = key;
        },
        setClearedTestKey(state) {
            let key = state.onTestKey;
            state.clearedTestKey = getClearedTestKey(key);
        }
    },
    actions: {
        async initTestStatus({ commit }) {
            var testStatus = await systemTestApi.getTestStatus();
            commit('setTestStatus', testStatus);
        },
        async initOnTestKey({ commit }) {
            var key = await systemTestApi.getTestKey();
            commit('setOnTestKey', key);
        },
        async placeOnTest({ commit, dispatch }, data) {
            data.startTime = toIsoString(data.startTime);
            var message = await systemTestApi.placeOnTest(data);
            if (message.Message) {
                commit('addError', message.Message);
            } else {
                await dispatch('initTestStatus');
                await dispatch('initOnTestKey');
            }

            return !message.Message;
        },
        async extendTest({ dispatch }, data) {
            data.endTime = toIsoString(data.endTime);
            var message = await systemTestApi.extendTest(data);
            if (message) {
                commit('addError', message);
            } else{
                await dispatch('initOnTestKey');
                await dispatch('initTestInfo');
            }

            return !message;
        },
        async clearTest({ state, commit, dispatch }) {
            await dispatch('initOnTestKey');
            commit('setClearedTestKey');
            await systemTestApi.clearTest();

            await dispatch('initTestStatus');
            await dispatch('initTestInfo');
            commit('setTestKey', state.clearedTestKey);
        }
    }
}